import user from '../api/user.api'
import userAvatar from '../api/user-avatar.api'
import store from './index.js'
// root state object.
// each Vuex instance is just a single state tree.
const state = {
  user: null,
  userList: [],
  userAvatarList: []
}

// mutations are operations that actually mutates the state.
// each mutation handler gets the entire state tree as the
// first argument, followed by additional payload arguments.
// mutations must be synchronous and can be recorded by plugins
// for debugging purposes.
const mutations = {
  setUser (state, currentUser) {
    state.user = currentUser
  },
  setUserList (state, currentUserList) {
    state.userList = currentUserList
  },
  setUserAvatarList (state, avatarList) {
    state.userAvatarList = avatarList
  }
}

// actions are functions that causes side effects and can involve
// asynchronous operations.
const actions = {
  getUserDetails (context) {
    user.api.getUserFromToken()
    .then(response => {
      context.commit('setUser', response.data)
    },
    error => {
      console.log('error when trying to get user detail : ')
      console.log(error)
    })
  },
  getUserList (context) {
    user.api.getUserList()
    .then(response => {
      context.commit('setUserList', response.data)
    },
    error => {
      console.log('error when trying to get user list : ')
      console.log(error)
    })
  },
  removeUser (context) {
    context.commit('setUser', null)
  },
  getAllUserAvatar (context) {
    userAvatar.api.getAllUserAvatar()
    .then(response => {
      context.commit('setUserAvatarList', response.data)
    },
    error => {
      console.log('error when trying to get user avatar list : ')
      console.log(error)
    })
  },
  createUserAvatar (context, userAvatar) {
    userAvatar.api.createUserAvatar(userAvatar)
    .then(response => {
      store.dispatch('getAllUserAvatar')
    },
    error => {
      console.log('error when trying to create user avatar : ')
      console.log(error)
    })
  }
}
// getters are functions
const getters = {
  currentUser: state => {
    return state.user
  },
  userList: state => {
    return state.userList
  },
  userAvatarList: state => {
    return state.userAvatarList
  },
  getUserAvatar: (state, getters) => (id) => {
    if (id) {
      let found = state.userAvatarList.find(avatar => { return avatar.user !== undefined && avatar.user === id })
      return found
    }
    return null
  },
  currentUserAvatar: state => {
    if (state.user) {
      let filtered = state.userAvatarList.filter(avatar => { return avatar.user !== undefined && avatar.user === state.user.id })
      return filtered[0]
    }
    return null
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}




// WEBPACK FOOTER //
// ./src/store/user.js